import React from "react";
import { node } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";

const i18nLabels = [
    ["echecks.cbuIssuing", "echecks.issuingAccount", "echecks.subAccount"],
    ["echecks.issuingHome", "echecks.postalCode", "echecks.entityCode"],
    ["echecks.entityName", "echecks.branchCode", "echecks.branchName"],
    ["echecks.address", "echecks.postalCode", "echecks.province"],
    ["echecks.echeckNumber", "echecks.echeckId", "echecks.echeckType"],
    ["echecks.echeckNature", "echecks.echeckMode", "echecks.echeckConcept"],
    ["echecks.echeckReason", "echecks.echeckReference", "echecks.echeckReferenceValue"],
    ["echecks.echeckBundlerId", "echecks.echeckLotId", "echecks.echeckAgreed"],
    ["echecks.echeckAgreementRequested", "echecks.echeckResubmitting", "echecks.echeckCertificateIssued"],
];

const keyValues = [
    ["emisor_cbu", "emisor_cuenta", "emisor_subcuenta"],
    ["emisor_domicilio", "emisor_cp", "emisor_banco_codigo"],
    ["emisor_banco_nombre", "emisor_sucursal_codigo", "emisor_sucursal_nombre"],
    ["emisor_domicilio", "emisor_cp", "emisor_sucursal_provincia"],
    ["numero_chequera", "cheque_id", "cheque_tipo"],
    ["cheque_caracter", "cheque_modo", "cheque_concepto"],
    ["cheque_motivo_pago", "referencia", "valorReferencia"],
    ["agrupador_id", "nro_lote", "cheque_acordado"],
    ["solicitando_acuerdo", "re_presentar", "certificado_emitido"],
];

const SeeMoreData = ({ echeckData }) => {
    const getEcheckData = (data) => {
        switch (data) {
            case null:
                return "N/A";
            case false:
                return "No";
            case true:
                return "Si";
            default:
                return data;
        }
    };

    const getTable = () => {
        let col = 1;
        let row = 1;
        const tempArray = [];

        const labelCounts = i18nLabels.flatMap((label) => label);
        for (let i = 1; i < labelCounts.length + 1; i++) {
            if ((col - 1) % 3 === 0) {
                col = 1;
                row += 1;
            }
            tempArray.push(
                <GridTable.Data columnStart={col} rowStart={row} rowWidth={1} alignX="flex-start" alignY="flex-start">
                    <GridTable.Container columns={1} rows={2}>
                        <GridTable.Data
                            columnStart={1}
                            rowStart={1}
                            rowWidth={1}
                            alignX="flex-start"
                            alignY="flex-start">
                            <CustomText text={i18nLabels[row - 2][col - 1]} textType="I18N" />
                        </GridTable.Data>
                        <GridTable.Data
                            columnStart={1}
                            rowStart={2}
                            rowWidth={1}
                            alignX="flex-start"
                            alignY="flex-start">
                            <span className="data-label">{getEcheckData(echeckData[keyValues[row - 2][col - 1]])}</span>
                        </GridTable.Data>
                    </GridTable.Container>
                </GridTable.Data>,
            );
            col += 1;
        }
        return tempArray;
    };

    return (
        <GridTable className="more-box box box-shadow information">
            <GridTable.Container columns={3} rows={10}>
                {getTable()}
            </GridTable.Container>
        </GridTable>
    );
};

SeeMoreData.propTypes = {
    echeckData: node.isRequired,
};

export default SeeMoreData;
